import {GuideModelV1} from 'resources/GeneratedModels/Guide/GuideModel.v1';
import {extensions} from './guide.extensions';
import {validators} from './guide.validators';

GuideModelV1.extend(extensions);
GuideModelV1.addValidators(validators);

export {GuideModelV1};
